import React, { useState } from 'react';
import { Card, Tooltip, token } from '@bynder/design-system';
import { IconImage, IconVideo } from '@bynder/icons';
import { PartialComponent } from 'packages/services/ComponentService';
import ComponentMenu from './ComponentMenu';
import ComponentThumbnail from './ComponentThumbnail';
import { DisabledCardWrapper, StyledBadge, StyledCard } from './styled';

interface Props {
    component: PartialComponent;
    collectionName: string;
    onClick: (isUniqueContentProperties: boolean) => void;
    onEdit: (component: PartialComponent) => void;
    onDelete: (component: PartialComponent) => void;
    isDisabled?: boolean;
}

const ComponentCard = ({ component, collectionName, onClick, onEdit, onDelete, isDisabled = false }: Props) => {
    const [isMenuOpen, setIsMenuOpen] = useState(false);

    const handleClick = () => {
        if (!isDisabled) {
            onClick(false);
        }
    };

    const cardContent = (
        <Tooltip
            isOpen={isMenuOpen ? false : undefined}
            content={component?.name ?? ''}
            position="top-left"
            timing="delay"
        >
            <StyledCard
                variant="clean"
                onClick={handleClick}
                contextAction={
                    <ComponentMenu
                        onOpen={() => {
                            setIsMenuOpen(true);
                        }}
                        onClose={() => {
                            setIsMenuOpen(false);
                        }}
                        component={component}
                        collectionName={collectionName}
                        onApply={onClick}
                        onEdit={() => onEdit(component)}
                        onDelete={() => onDelete(component)}
                        isDisabled={isDisabled}
                    />
                }
                noMinWidth
            >
                <Card.Frame
                    badge={
                        component.type === 'IMAGE' ? (
                            <StyledBadge
                                variant="clean"
                                icon={<IconImage size="18" />}
                                iconColor={token.white}
                                backgroundColor={token.gray400a}
                                size="xs"
                            />
                        ) : (
                            <StyledBadge
                                variant="clean"
                                icon={<IconVideo size="18" />}
                                iconColor={token.white}
                                backgroundColor={token.gray400a}
                                size="xs"
                            />
                        )
                    }
                >
                    <ComponentThumbnail component={component} />
                </Card.Frame>
            </StyledCard>
        </Tooltip>
    );

    if (isDisabled) {
        return <DisabledCardWrapper>{cardContent}</DisabledCardWrapper>;
    }

    return cardContent;
};

export default ComponentCard;
